/**
 * This is a dummy map file. By default, the workflow settings code is loaded from the database.
 * This is really inconvenient for development, as every code change requires a database update.
 * To work around this the workflowMap.ts file is used to load the workflow settings code from a
 * file which can be placed under local/FieldServices/react/features/workflow/workflowMap.ts.
 * That way, the workflow settings code can be changed without a database update.
 *
 * In the override file placed under local the mapping can be defined like this:
 *
 * const workflowMap = {
 *      1: require('@powerednow/workflows/dist/invoiceReminder/v1/settings.js?source'),
 *      2: require('@powerednow/workflows/dist/invoiceReminder/v1/settings.js?source'),
 *      }
 */
const workflowMap = {};

export default workflowMap;
